import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "boxed-variable" };
import { useBuiltCampaignComponentVariable } from "src/shared/store/component-built/composables";
import { computed, toRef } from "vue";
import { isExpression } from ".";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuildtimeVariableSegment',
    props: {
        value: {},
        componentId: {},
        dimension: {}
    },
    setup(__props) {
        const props = __props;
        const { builtCampaignComponentVariable } = useBuiltCampaignComponentVariable(toRef(props, "componentId"), toRef(props, "value"));
        const values = computed(() => {
            var _a;
            return (_a = builtCampaignComponentVariable.value) === null || _a === void 0 ? void 0 : _a.values;
        });
        const builtValue = computed(() => {
            if (!values.value) {
                return undefined;
            }
            return (values.value[props.dimension] ||
                values.value["en"] ||
                values.value["default"]);
        });
        const shouldDisplayVariableValue = computed(() => {
            return builtValue.value !== undefined && !isExpression(builtValue.value);
        });
        const displayValue = computed(() => {
            return shouldDisplayVariableValue.value ? builtValue.value : props.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(displayValue.value), 1 /* TEXT */));
        };
    }
});
